import { Badge } from "@web-shared/components/ui/badge";

/** Marks the beta deployment, whose accounts and seeds are its own. */
export function BetaBadge() {
  return (
    <Badge variant="changed" title="The beta channel: its own accounts and its own seeds">
      beta
    </Badge>
  );
}
